import { c as _c } from "react/compiler-runtime";
import { forwardRef, useState } from 'react';
import InnerDrawer from './components/inner-drawer';
type DetailsLayoutWrapperProps = {
  children: React.ReactNode;
  drawerChildren?: React.ReactNode;
};
const DetailsLayoutWrapper = forwardRef<HTMLDivElement, DetailsLayoutWrapperProps>((t0, ref) => {
  const $ = _c(15);
  const {
    children,
    drawerChildren
  } = t0;
  const hasDrawer = Boolean(drawerChildren);
  const [drawerOpen, setDrawerOpen] = useState(hasDrawer);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setDrawerOpen(_temp);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleDrawerToggle = t1;
  let t2;
  if ($[1] !== drawerOpen || $[2] !== hasDrawer) {
    t2 = hasDrawer ? {
      gridTemplateColumns: drawerOpen ? "var(--drawer-width) 1fr" : "1px 1fr"
    } : undefined;
    $[1] = drawerOpen;
    $[2] = hasDrawer;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== drawerChildren || $[5] !== drawerOpen) {
    t3 = drawerChildren && <InnerDrawer open={drawerOpen} onClose={handleDrawerToggle} onOpenChange={setDrawerOpen}><div className="flex flex-col gap-6 p-4 md:p-6">{drawerChildren}</div></InnerDrawer>;
    $[4] = drawerChildren;
    $[5] = drawerOpen;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== children || $[8] !== ref) {
    t4 = <div ref={ref} className="flex justify-center w-full flex-1 min-h-0 md:flex-none md:min-h-auto md:h-full bg-secondary p-4 md:p-6 overflow-y-auto relative">{children}</div>;
    $[7] = children;
    $[8] = ref;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== hasDrawer || $[11] !== t2 || $[12] !== t3 || $[13] !== t4) {
    t5 = <div className="bg-secondary h-full overflow-hidden flex flex-col [--drawer-width:0px] md:block md:[--drawer-width:450px] md:data-[has-drawer=true]:grid data-[has-drawer=true]:[grid-template-areas:'drawer_content'] data-[has-drawer=true]:transition-[grid-template-columns] data-[has-drawer=true]:duration-200 data-[has-drawer=true]:ease-in-out" style={t2} data-has-drawer={hasDrawer}>{t3}{t4}</div>;
    $[10] = hasDrawer;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
});
export default DetailsLayoutWrapper;
function _temp(currentOpen) {
  return !currentOpen;
}